module.exports = __webpack_public_path__ + "static/img/ddddddddddd.bfa22ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/welcome/ddddddddddd.png
// module id = xrsb
// module chunks = 0